import {get, isDigit} from 'ldash'

import {fetch} from 'uix/api'
import {hashObj} from 'uix/utils'

export const getErrorEnvDetails = root => ({
  pathname: root.meta.request.pathname,
  package: root.config.deploy ? root.config.deploy.package : null,
  otid: isDigit(root.meta.request.id) ? root.meta.request.id : undefined,
  username: get(root, 'meta.user.name', undefined),
})

let STACKTRACEY = null
let REPORTED = new Set([])
export const reportError = (type, store, error, more) => {
  let root = store.getState()

  let send = stack => {
    let errorMessage = error.toString().split('\n')[0]
    let errorInfo = {message: errorMessage, stack, ...more}
    let {apiurl} = root.config
    let params = {
      type,
      error: JSON.stringify(errorInfo),
      ...getErrorEnvDetails(root),
    }
    let reported_key = hashObj(params)
    if (!REPORTED.has(reported_key)) {
      // synchronous fetch - we have left saga space
      fetch({apiurl, path: '/api/reportError', method: 'post', params})
    }
    REPORTED.add(reported_key)
  }
  if (root.config.deploy.mode != 'npm') {
    let format = () =>
      new STACKTRACEY(error)
        .withSources()
        .clean()
        .asTable()
    if (!STACKTRACEY) {
      import(/* webpackChunkName: 'stacktracey' */ 'stacktracey').then(module => {
        STACKTRACEY = module.default
        send(format())
      })
    } else {
      send(format())
    }
  }
}
// reset in ssr tests
export const resetErrorTracker = () => REPORTED.clear()
